import React from 'react';
import CloudMonitorPage from './CloudMonitorPage';

export default function CloudMonitorAzure() {
  return <CloudMonitorPage provider="azure" />;
}
